import { render, staticRenderFns } from "./mapAlignFormPanel.vue?vue&type=template&id=2284b962&scoped=true"
import script from "./mapAlignFormPanel.vue?vue&type=script&lang=js"
export * from "./mapAlignFormPanel.vue?vue&type=script&lang=js"
import style0 from "./mapAlignFormPanel.vue?vue&type=style&index=0&id=2284b962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284b962",
  null
  
)

export default component.exports